import axiosClient from "../axiosClient";

export const getEvent = async () => {
    return await axiosClient.get('/all_seminar_event');
};

export const getEventById = async (id) => {
    return await axiosClient.get(`/seminar_event_by_id/${id}`);
};

export const getEventTags = async () => {
    return await axiosClient.get('/get_se_tag_list');
};

export const addEvent = async (data) => {
    return await axiosClient.post('/add_seminar_events', data);
};

export const editEvent = async (data) => {
    return await axiosClient.put('/edit_seminar_events', data);
};

export const deleteEvent = async (id) => {
    return await axiosClient.delete(`/delete_seminar_events/${id}`);
};

export const getEventGroupDetails = async (id) => {
    return await axiosClient.get(`/get_events_group_details/${id}`);
};

export const editStatus = async (data) => {
    return await axiosClient.put(`/edit_seminar_events_status`, data);
};

export const getEventAttendee = async (id) => {
    return await axiosClient.get(`/get_seminar_event_attendee/${id}`);
};

export const addRecommendedEvent = async (data) => {
    return await axiosClient.post(`/add_recomended_seminar_event`, data);
};

export const getRecommendedEvent = async () => {
    return await axiosClient.get(`/get_recomended_seminar_event`);
};

export const getFreeClasses = async () => {
    return await axiosClient.get('/all_free_class');
};

export const deleteFreeClasses = async (id) => {
    return await axiosClient.delete(`/delete_free_class/${id}`);
};

export const getFreeClassAttendee = async (id) => {
    return await axiosClient.get(`/get_free_class_attendee/${id}`);
};

export const getFreeClassById = async (id) => {
    return await axiosClient.get(`/free_class_by_id/${id}`);
};

export const editFreeClass = async (data) => {
    return await axiosClient.put('/edit_free_class', data);
};

export const addFreeClass = async (data) => {
    return await axiosClient.post('/add_free_class', data);
};

export const editFreeClassStatus = async (data) => {
    return await axiosClient.put(`/edit_free_class_status`, data);
};

export const addRecommendedFreeClass = async (data) => {
    return await axiosClient.post(`/add_recomended_free_class`, data);
};

export const getRecommendedFreeClass = async () => {
    return await axiosClient.get(`/get_recomended_free_class`);
};

export const getFreeClassTags = async () => {
    return await axiosClient.get('/get_fc_tag_list');
};